import { PropsWithChildren, useEffect } from 'react';

import { fetchRemoteConfig } from '../remote-config';
import { useRemoteConfigStore } from '../stores/remote-config-store';

const RemoteConfigProvider = ({ children }: PropsWithChildren) => {
    const { setConfig } = useRemoteConfigStore();

    useEffect(() => {
        fetchRemoteConfig()
            .then(setConfig)
            .catch((err) => console.error('[RemoteConfig] fetch failed:', err));
    }, []);

    return <>{children}</>;
};

export default RemoteConfigProvider;
